module.exports = __webpack_public_path__ + "static/media/phone2.01ddd1c8.svg";